import type { RenderContext } from 'lorena-templates'
import { resolveFileUrl } from '../../../lib/files'
import type { SlideDraft } from '../types'

/** Resolve o `ctx` (imagem + recorte) de um slide a partir do que está salvo no PocketBase. */
export function slideToCtx(slide: SlideDraft): RenderContext {
  if (!slide.imageFileId) return {}
  return {
    imageUrl: resolveFileUrl('slides', slide.id, slide.imageFileId, slide.updated),
    imageCrop: slide.imageTransform ?? null,
  }
}
